import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { errorHandler } from "../../../util/errorHandler";
import PayApi from "../../../api/pay.api";
import moment from "moment";

const PayDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  // mounted
  useEffect(() => {
    getPayInfo();
  }, []);

  // ----- 정보 가져오기
  const [payInfo, setPayInfo] = useState({});

  const getPayInfo = async () => {
    try {
      const response = (await PayApi.getById(id)).data.data.content;
      setPayInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <DetailPageForm>
                <DetailFormTitle>결제번호</DetailFormTitle>
                <DetailFormText>{payInfo.orderNumber}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제일자</DetailFormTitle>
                <DetailFormText>{moment(payInfo.createdAt).format("YYYY/MM/DD")}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제수단</DetailFormTitle>
                <DetailFormText>{payInfo.payMethod}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>구매자 정보</DetailFormTitle>
                <div>
                  <DetailFormText>{payInfo.name}</DetailFormText>
                  <DetailFormText>{payInfo.phoneNumber}</DetailFormText>
                  <DetailFormText>{payInfo.email}</DetailFormText>
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>강의명</DetailFormTitle>
                <DetailFormText>{payInfo.lectureTitle}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>쿠폰</DetailFormTitle>
                <DetailFormText>-{payInfo.couponPay?.toLocaleString()}원</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>결제금액</DetailFormTitle>
                <DetailFormText>{payInfo.realPay?.toLocaleString()}원</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default PayDetail;
